// src/components/SuccessPage.jsx
import React from 'react';
import './SuccessPage.css'; // Import CSS for styling

function SuccessPage() {
  return (
    <div className="success-container">
      <h2>Parabéns!</h2>
      <p>Sua peça será impressa, e entraremos em contato via Whatsapp para a retirada!</p>
    </div>
  );
}

export default SuccessPage;
